<div class="insurance-container" *ngIf="!loading; else loadingTemplate">
  <!-- Header with title and manage button -->
  <div class="insurance-header">
    <h2>Insurance Information</h2>
    <button mat-stroked-button (click)="manageInsurance()" class="manage-button">
      Manage Insurance
    </button>

    <div class="action-container" *ngIf="processedInsuranceInfo.length > 0">
    <button mat-stroked-button class="download-button" (click)="generatePdf()">
      <mat-icon>download</mat-icon>
      Download
    </button>
  </div>
  </div>

  <div id="insurance-content">
    <ng-container *ngIf="processedInsuranceInfo.length > 0; else noInsuranceHistory">
      <mat-accordion>
        <mat-expansion-panel *ngFor="let insurance of processedInsuranceInfo; let i = index">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ insurance.generalInfo.carrier }}
            </mat-panel-title>
            <!-- <mat-panel-description>
              Subscriber: {{ insurance.generalInfo.subscriberName }}
            </mat-panel-description> -->
          </mat-expansion-panel-header>

          <!-- General Info -->
          <div class="general-info">
            <h3>General Info</h3>
            <div class="info-grid">
              <div class="label">Insurance Provider:</div>
              <div class="value">{{ insurance.generalInfo.carrier }}</div>
              <div class="label">Employer:</div>
              <div class="value">{{ insurance.generalInfo.employer }}</div>
              <div class="label">Group Name:</div>
              <div class="value">{{ insurance.generalInfo.groupName }}</div>
              <div class="label">Group Number:</div>
              <div class="value">{{ insurance.generalInfo.groupNumber }}</div>
              <div class="label">Subscriber:</div>
              <div class="value">
                {{ insurance.generalInfo.subscriberName }} ({{ insurance.generalInfo.relationship }})
              </div>
              <div class="label">Subscriber ID:</div>
              <div class="value">{{ insurance.generalInfo.subscriberID }}</div>
            </div>
          </div>

          <!-- Coverage Summary -->
          <div class="coverage-summary">
            <h3>Coverage Summary</h3>
            <ul>
              <li *ngFor="let coverage of insurance.coveragePercentages">
                {{ coverage.service }}: {{ coverage.percentage }}%
              </li>
            </ul>
          </div>

          <!-- Deductibles -->
          <div class="deductibles">
            <h3>Deductibles</h3>
            <ul>
              <li *ngFor="let deductible of insurance.deductibles">
                {{ deductible.category }}: ${{ deductible.amount }} per {{ deductible.timePeriod }}
              </li>
            </ul>
          </div>

          <!-- Limitations -->
          <div class="limitations">
            <h3>Limitations</h3>
            <ul>
              <li *ngFor="let limitation of insurance.limitations">
                {{ limitation }}
              </li>
            </ul>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-container>

    <ng-template #noInsuranceHistory>
      <div class="no-entries">
        <mat-icon class="info-icon">info</mat-icon>
        <span>No insurance history found.</span>
      </div>
    </ng-template>
  </div>
</div>

<ng-template #loadingTemplate>
  <div class="loading-container">
    <mat-spinner [diameter]="50" color="primary"></mat-spinner>
  </div>
</ng-template>